
$(document).ready(function() {

	$("#step-val").val(1);

	/* Daten, je nach gewähltem produkt, anpassen */
	$("#sel_product").change(function() {
		$.ajax({
			type: "POST",
			url: "/ad/productinfo",
			dataType: "json",
			data: { "product_id": $("#sel_product").val() },
			headers: { "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content") },
			success: function(response, textStatus) {
				$("#product_headline").html(response.title);
				$("#product_price").html(parseFloat(response.price).toLocaleString(undefined,{minimumFractionDigits: 2}).replace(",00", ",-") + " \u20AC");
				$("#product_tax").html("zzgl. " + response.tax + "% MwSt.");
				$("#product_uptime").html("Laufzeit: " + response.uptime);
				$("#product_until").html("Die Anzeige läuft bis einschl. " + response.runs_until);
				$("#product").val(response.id);
				$("#price").val(response.price);
				$("#tax").val(response.tax);
				$("#date_from").val(response.date_from);
				$("#date_until").val(response.date_until);
				//$("#product-description").html(response.description);
				if (response.logo == 1) {
					$("#company-logo-form").css("display", "block");
				} else {
					$("#company-logo-form").css("display", "none");
				}

				if (response.has_discount >= 1) {
					$("#discount").css("display", "block");
				} else {
					$("#discount").css("display", "none");
				}
				$("#discount-msg").html("");
				$("#discount-price").html("");
			}
		});
	});

	$(".job-ad #step-1 .product-info").popover({
		trigger: "focus",
		html: true,
		title: function() {
			return $("#sel_product").find(":selected").data("title");
		},
		content: function() {
			return $("#sel_product").find(":selected").data("description").replace(/\n/g, "<br>");
		}
	});

	$("#discount_code").on('keypress', function(e) {
        var charInput = e.keyCode;
        if((charInput >= 97) && (charInput <= 122)) { // lowercase
            if(!e.ctrlKey && !e.metaKey && !e.altKey) { // no modifier key
                var newChar = charInput - 32;
                var start = e.target.selectionStart;
                var end = e.target.selectionEnd;
                e.target.value = e.target.value.substring(0, start) + String.fromCharCode(newChar) + e.target.value.substring(end);
                e.target.setSelectionRange(start+1, start+1);
                e.preventDefault();
            }
        }
	});
	$("#check_discount").click(function() {
		$.ajax({		
			type: "POST",
			url: "/ad/discount-code",
			dataType: "json",
			data: { "product_id": $("#sel_product").val(), "code": $("#discount_code").val() },
			headers: { "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content") },
			success: function(response, textStatus) {
				$("#discount-msg").html(response.msg);
				$("#discount-price").html(response.discount);
			}
		});
	});

	/* Einen Screen zurück navivieren */
	$(".step-prev").click(function(){
		var form_id = parseInt($("#step-val").val()) - 1;
		toggle_form(form_id, 0);
	});

	/* Einen Screen vorwärts navigieren */
	$(".step-next").click(function(){
		var form_id = parseInt($("#step-val").val()) + 1;
		toggle_form(form_id, 1);
	});

	if($('#__mode__').val() == 'edit') {
		$(".info-headline table.hints .item").addClass('pointer');
		$(".info-headline table.hints .item").click(function() {
			var form_id = $(this).parent("td").index() + 1;
			toggle_form(form_id, 1);
		});
	}

	/* Daten speichern */
	if ($('#__mode__').val() == 'edit') {
		$(".step-save").show();
	}
	$(".step-save").click(function() {
		process_order();
	});

	/* PDF Format gewählt */
	$("#format-pdf").click(function() {
		$(this).addClass("bold");
		$("#format-html").removeClass("bold");
		$("#html-upload").css("display", "none");
		$("#pdf-job").css("display", "block");
		$("#format").val('pdf');
	});

	/* HTML Format gewählt */
	$("#format-html").click(function() {
		$(this).addClass("bold");
		$("#format-pdf").removeClass("bold");
		$("#pdf-job").css("display", "none");
		$("#html-upload").css("display", "block");
		$("#format").val('html');
	});
	
	/* Zahlungsmethode - hier noch nicht verwendet !! */
	$(".payment_method").change(function() {
		$(".payment_method").not(this).prop("checked", false);  
		$("#payment_method").val($(this).val());
	});

	/* AGBs */
	$("#invoice_agb").change(function() {
		if ($(this).is(":checked")) {
			$("#agb").val(1);
		} else {
			$("#agb").val("");
		}
	});

	/* Datenschutzbestimmungen */
	$("#sec_confirm").change(function() {
		if ($(this).is(":checked")) {
			$("#sec").val(1);
		} else {
			$("#sec").val("");
		}
	});	

	$("#upload-filename-pdf").change(function() {
		var filename = $("#upload-filename-pdf").val().replace(/C:\\fakepath\\/i, '');
		$("#selected-file-pdf").html(filename + ' wurde ausgewählt. Bitte klicken Sie auf UPLOAD um die Datei hochzuladen.');
		$("#upload-pdf").css("display", "block");
	});

	$("#upload-filename").change(function() {
		var filename = $("#upload-filename").val().replace(/C:\\fakepath\\/i, '');
		$("#selected-file").html(filename + ' wurde ausgewählt. Bitte klicken Sie auf UPLOAD um die Datei hochzuladen.');
		$("#upload").css("display", "block");
	});

	/* Upload Logos */
	$('#upload').on('click', function() {
	    var file_data = $('#upload-filename').prop('files')[0];   
	    var form_data = new FormData(); 
	    if (typeof file_data === "undefined") return;                 
	    form_data.append('upload', file_data);
	    form_data.append('sid', $("#upload-sid").val());
	    form_data.append('uid', $("#upload-uid").val());
	    form_data.append('upload_type', $("#upload-type").val());
	    $.ajax({
            url: "/ajax/upload", 
            dataType: "json",  
            cache: false,
            contentType: false,
            processData: false,
            data: form_data,                         
            headers: { "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content") },
            type: "POST",
            success: function(response, textStatus){
            	$("#selected-file").html("Upload erfolgreich");
            	$("#upload").css("display", "none");            	
                $("#upload-msg").html(response.msg);
                $("#logo_filename").val(response.filename);
                $("#company-logo").attr("src", response.filename);
            }
 		});
	});

	/* Upload PDFs */
	$('#upload-pdf').on('click', function() {
	    var file_data = $('#upload-filename-pdf').prop('files')[0];   
	    var form_data = new FormData();       
	    if (typeof file_data === "undefined") return;                            
	    form_data.append('upload', file_data);
	    form_data.append('uid', $("#upload-uid").val());
	    form_data.append('upload_type', 'pdf');
	    $.ajax({
            url: "/ajax/upload", 
            dataType: "json",  
            cache: false,
            contentType: false,
            processData: false,
            data: form_data,   
            headers: { "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content") },                      
            type: "POST",
            success: function(response, textStatus){
            	$("#selected-file-pdf").html("Upload erfolgreich");
            	$("#upload-pdf").css("display", "none");
                $("#pdf-view").attr("src", response.filename);
                $("#pdf_name").val(response.filename);
            }
 		});
	});

	/* Abweichende Rechnungsanschrift */
    $("#invoice_address").click(function() {
    	if ($(this).is(":checked")) {
    		$("#invoice_data").css("display", "block");
    	} else {
    		$("#invoice_data").css("display", "none");
    	}
    });

    /* Unterscheidung Neu- oder Bearbeiten-Modus */
    if (!$("#record_id").val()) {
        $("#sel_product").trigger("change");
        $("#format-html").trigger("click");
    } else {
        if ($("#format").val() == 'pdf') {
            $("#format-pdf").trigger("click");
            $("#pdf-view").attr("src", "/uploads/" + $("#upload-sid").val() + "/pdf/" + $("#record_id").val() + ".pdf");
        } else {
            $("#format-html").trigger("click");
        }
    }

    $("#extend").click(function() {
    	$('#extend').css("display", "none");
    	var agb = ($("#agb").is(":checked")) ? "1" : "0";	
    	var sec = ($("#sec").is(":checked")) ? "1" : "0";	
    	var ad_id = $(this).data("id");

		$.ajax({
			type: "POST",
			url: "/ad/extend-order",
			dataType: "json",
			data: { "ad_id": ad_id, "agb": agb, "sec": sec },
			headers: { "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content") },
			success: function(response, textStatus) {
				if (response.ok) {
					$('#msg').removeClass("error").addClass("success").html(response.msg);
					$('#extend').css("display", "none");
				} else {
					$('#msg').removeClass("success").addClass("error").html(response.msg);
					$('#extend').css("display", "block");
				}
			}
		});			


    });

});

window.process_order = function () {

	var info = collect_ad_data();
	var err = "";
	for (let step = 1; step < 5; step++) {
		err += check_input(info, step);
	}
	var msg = "";

	if (err.length > 0) {
		return;
	}

	$(".step-save").prop("disabled", true).addClass("disabled");
	$.ajax({
		type: "POST",
		url: "/ad/order",
		dataType: "json",
		data: info,
		headers: { "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content") }
	}).done(function(response, textStatus) {
		$(window).unbind("beforeunload");
		location.href = "/ad/confirmation?id=" + response.ad_id + "&mode=" + info.__mode__;
	}).fail(function() {
		$("#msg").html("Bei der Verarbeitung ist ein Fehler aufgetreten");
		$(".step-save").prop("disabled", true).addClass("disabled");
	});
}

window.toggle_form = function (form_id, check_error) {

	var info = collect_ad_data();
	var current_step = $("#step-val").val();

	if (check_error) {
		var err = check_input(info, current_step);	
	} else {
		var err = [];
	}

	if (err.length > 0) {
		return;
	}

	// Vorschau auf Seite 2 & Seite 4
	if (form_id == 2 || form_id == 4) {
		setPreviewData();
	}


	$("#number-" + form_id).addClass("success");

	$(".form-step").each(function() {
		if (!$(this).hasClass("hidden")) {
			$(this).addClass("hidden");
		}
	});

	$("#step-val").val(form_id);

	if (form_id == 4) {
		$(".step-save").show();
	}

	$("#step-" + form_id).removeClass("hidden");

	$(".step-prev").toggleClass("invisible", form_id <= 1);
	$(".step-next").toggleClass("invisible", form_id == 4);

}

window.collect_ad_data = function () {

	var data = {};
	var key;
	var classname;
	$(".ad").each(function(){
		key = $(this).attr("id");
		classname = $(this).attr("class");
		if (classname.indexOf("ckeditor") >= 0) {
			var method = "CKEDITOR.instances." + key + ".getData()";
			data[key] = eval(method);
		} else if (classname.indexOf("checkbox") >= 0) {
			data[key] = ($(this).is(":checked")) ? "1" : "0";	
		} else {
			data[key] = $(this).val();
		}
	});
	
	if (typeof(data["price"]) !== "undefined") {
		data["price"] = data["price"].replace(",", ".");
	}

	return data;

}

window.check_input = function (info, step) {

	var err = [];
	var items = [];
	var fields = [];

	$(".number").each(function(){
		$(this).removeClass("current");
	});

	switch (step) {
		case "1": 
		
			if ($("#format").val() == "pdf") {
				items = [ "job_title", "pdf_name" ];
			} else {
				items = [ "job_title", "description_job" ];	
			}
			// Wenn E-Mail als Bewerbungsmethode ausgewählt wurde
			if (info["apply-2"] == 1) {
				items.push("email");
			}
			// Wenn es Channel in der Instanz gibt
			if ($("#channel").length > 0) {
				items.push("channel");
			}
			items.push("teaser_job");
			break;

		case "2":
			items = [];
			break;

		case "3":
			items = [ "company", "street", "zip", "city", "com_email" ];
			if ($("#invoice_address").is(':checked')) {
				if ($("#invoice_country").val() != 'DE') {
					items.push("invoice_company");
					items.push("invoice_street");
					items.push("invoice_zip");
					items.push("invoice_city");
					items.push("tax_id");
				} else {
					items.push("invoice_company");
					items.push("invoice_street");
					items.push("invoice_zip");
					items.push("invoice_city");
				}	
			} else {
				if ($("#country").val() != 'DE') {
					items.push("tax_id");
				} 
			}
			break;

		case "4":
			items = [ "agb", "payment_method", "sec" ];
			break;

		default:
			items = [];
	}

    items.forEach(function (fieldName, fieldIndex, fieldList) {
        var node = $("#lbl_" + fieldName);
        var value = info[fieldName];
        var isValid = (info[fieldName].length > 0);
        var isEmail = (fieldList[fieldIndex] === "email" || fieldList[fieldIndex] === "com_email");
        if (isEmail) {
            isValid = isValidEmail(value);
        }
        if (fieldName != "agb" && fieldName != "sec") {
	        if (isValid === false) {
	            err.push(fieldName);
	            node.addClass("error");
	            fields.push(node.html());
	        } else {
	            node.removeClass("error");
	        }
		}
    });

	if (step == "1") {
		var apply1 = ($("#apply-1").is(':checked')) ? 1 : 0;
		var apply2 = ($("#apply-2").is(':checked')) ? 2 : 0;
		var apply4 = ($("#apply-4").is(':checked')) ? 4 : 0;
		var apply = apply1 + apply2 + apply4;

		if (apply == 0) {
			$("#lbl_apply_method").addClass("error");
			err.push('apply_method');
			fields.push($("#lbl_apply_method").html());
		} else {
			$("#lbl_apply_method").removeClass("error");
		}
		$("#apply_method").val(apply);

		if (apply >= 4 && $("#apply_url").val().length == 0) {
			$("#lbl_apply_url").addClass("error");
			err.push('apply_url');
			fields.push($("#lbl_apply_url").html());
		} else {
			$("#lbl_apply_url").removeClass("error");
		}

		if ($("#com_email").val().length == 0) {
			$("#com_email").val($("#email").val());	
		}
	
	}

	if (step == "4") {
		if (!$("#record_id").val()) {
			if (!$("#sec").is(':checked')) {
				$("#lbl_agb").addClass("error");
				err.push('sec');
				fields.push("Datenschutzhinweis");
			}
			if (!$("#agb").is(':checked')) {
				$("#lbl_agb").addClass("error");
				err.push('agb');
				fields.push("AGB");
			}
		}
	}

	if (err.length) {
		$("#number-" + step).removeClass("success");
		$("#number-" + step).addClass("error");
		$("#msg").html("Bitte folgende Felder ausfüllen: " + fields.join(", "));
		$("html, body").animate({ scrollTop: 0 }, "slow");
	} else {
		$("#number-" + step).removeClass("error");
		$("#number-" + step).addClass("success");
		$("#msg").html("");
	}
	return err;

}

/**
 *
 * @param {string} email
 * @returns {boolean}
 */
window.isValidEmail = function (email) {
    var filter = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;

    return filter.test(email);
}

window.cb_toggle = function (name) {

	if ($('#' + name).is(":checked")) {
		$('#' + name).prop("checked", false);
	} else {
		$('#' + name).prop("checked", true);
	}
            
} 

window.setPreviewData = function() {

	var info = collect_ad_data();
	console.log(info);
	$.ajax({
		type: "POST",
		url: "/ad/preview",
		dataType: "html",
		data: info,
		headers: { "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content") },
	}).done(function(response) {
		$(".adpreview").each(function() {
			$(this).get(0).srcdoc = response;
		});
	});
}




// WEBPACK FOOTER //
// ./resources/js/ad.js